import React, { useState, useEffect } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { getFirestore, collection, addDoc, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import styles from './Dashboard.module.css';
import chevronImage from './chevron.png';

function Dashboard() {
  const [showModal, setShowModal] = useState(false);
  const [projectName, setProjectName] = useState('');
  const [projects, setProjects] = useState([]);

  const navigate = useNavigate();
  const auth = getAuth();
  const userId = auth.currentUser?.uid; // Make sure currentUser is not null

  useEffect(() => {
    const fetchProjects = async () => {
      const db = getFirestore();
      const projectsRef = collection(db, 'projects');
      const q = query(projectsRef, where("userId", "==", userId));
      const querySnapshot = await getDocs(q);
      setProjects(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
    };

    if (userId) {
      fetchProjects();
    }
  }, [userId]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/signIn');
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const handleCreateProject = async () => {
    if (projectName.trim() === '') {
      alert('Project name cannot be empty');
      return;
    }

    if (projects.length >= 1) {
      alert('You have reached the project limit.');
      return;
    }

    const newProject = {
      name: projectName,
      userId: userId
    };

    const db = getFirestore();
    const projectsRef = collection(db, 'projects');

    try {
      const docRef = await addDoc(projectsRef, newProject);
      setProjectName('');
      navigate(`/projectPage/${docRef.id}`, { state: { projectName: newProject.name, projectId: docRef.id } });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const handleDeleteProject = async (projectId) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      const db = getFirestore();
      try {
        await deleteDoc(doc(db, 'projects', projectId));
        setProjects(projects.filter(project => project.id !== projectId));
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.headerContainer}>
        <h1 className={styles.headerDashboard}>Dashboard</h1>
        <div className={styles.buttonsContainer}>
          <button 
              className={styles.createButton} 
              onClick={() => setShowModal(true)}
          >
            Create Project
          </button>
          <button className={styles.logoutButton} onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      <div className={styles.projectsContainer}  >
        {projects.length === 0 ? (
          <p className={styles.noProjectsMessage}>
            You haven't created any projects yet. Tap the Create Project button in the top right to create your first project.
          </p>
        ) : (
          projects.map(project => (
            <div 
              key={project.id} 
              className={styles.projectCard}
              
            >
              <span style={{cursor: 'pointer'}} onClick={() => navigate(`/projectPage/${project.id}`, { state: { projectName: project.name, projectId: project.id } })}>{project.name}</span>
<div className={styles.projectDeleteChevronContainer}> 
<button className={styles.projectDeleteButton} onClick={() => handleDeleteProject(project.id)}>Delete</button>
              <img onClick={() => navigate(`/projectPage/${project.id}`, { state: { projectName: project.name, projectId: project.id } })} src={chevronImage} alt="Chevron Icon" style={{ width: '8px', height: '14px', cursor: 'pointer'  }} />
</div>
              
            </div>
          ))
        )}
      </div>

      {/* Create project modal */}
      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h1>Create Project</h1>
            <input 
              className={styles.projectInputField}
              type="text" 
              placeholder="Project Name"
              value={projectName} 
              onChange={(e) => setProjectName(e.target.value)}
            />
            <div className={styles.createProjectButtonContainer}> 
              <button className={styles.cancelButton} onClick={() => setShowModal(false)}>Cancel</button>
              <button className={styles.submitButton} onClick={handleCreateProject}>Create</button>
              </div>
            
          </div>
        </div>
      )}
 
     
    
    </div>
  );
}

export default Dashboard;


// {showPaymentModal && (
//   <div className={styles.modalOverlay}>
//   <PaymentModalComponent onClose={() => setShowPaymentModal(false)} />
//   </div>
// )}